import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: [], // array of products in cart
  quantity: 0, // total number of items
  totalPrice: 0, // total price
  status: "idle", // could be "idle", "pending", "completed"
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existing = state.cartItems.find((item) => item._id === product._id);
      console.log(product);
      if (existing) {
        existing.quantity += 1;
        existing.totalPrice = existing.variants[0].price * existing.quantity;
      } else {
        state.cartItems.push({
          ...product,
          quantity: 1,
          totalPrice: product.variants[0].price,
        });
      }

      state.quantity = state.cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0,
      );
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.totalPrice,
        0,
      );
    },

    removeFromCart: (state, action) => {
      const id = action.payload;
      state.cartItems = state.cartItems.filter((item) => item._id !== id);
      state.quantity = state.cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0,
      );
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.totalPrice,
        0,
      );
    },

    increaseQuantity: (state, action) => {
      const id = action.payload;
      const item = state.cartItems.find((item) => item.id === id);
      if (item) {
        item.quantity += 1;
        item.totalPrice = item.price * item.quantity;
      }
      state.quantity = state.cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0,
      );
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.totalPrice,
        0,
      );
    },

    decreaseQuantity: (state, action) => {
      const id = action.payload;
      const item = state.cartItems.find((item) => item.id === id);
      if (item && item.quantity > 1) {
        item.quantity -= 1;
        item.totalPrice = item.price * item.quantity;
      } else if (item && item.quantity === 1) {
        // remove item if quantity becomes 0
        state.cartItems = state.cartItems.filter((item) => item.id !== id);
      }
      state.quantity = state.cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0,
      );
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.totalPrice,
        0,
      );
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.quantity = 0;
      state.totalPrice = 0;
      state.status = "idle";
    },

    setStatus: (state, action) => {
      state.status = action.payload; // e.g., "pending", "completed"
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
  setStatus,
} = cartSlice.actions;

export default cartSlice.reducer;
